import {ParticipationType} from "./ParticipationType";

export interface Speaker {
    uiId: number;
    firstName: string;
    lastName: string;
    email: string;
    order: number;
}

export interface SpeakerInvitationCreateLocation {
    name: string;
    streetAndNumber: string;
    postalCode: string;
    city: string;
    country: string;
}

export interface SpeakerInvitationCreateBanquetLocation extends SpeakerInvitationCreateLocation {

}

export interface SpeakerInvitationCreateBanquet {
    banquetLocation: SpeakerInvitationCreateBanquetLocation;
}

export interface SpeakerInvitationDaySlot {
    timeFrom: string;
    timeTo: string;
    isLunch: boolean;
    uiId: number | undefined;
    checked: boolean;
    disabled: boolean;
}

export interface SpeakerInvitationDay {
    date: Date;
    participationType: ParticipationType | undefined;
    allowedParticipationType: AllowedParticipationType;
    slots: SpeakerInvitationDaySlot[];
}

export interface SpeakerInvitationCreateMessage {
    invitationId: string;
    conferenceName: string;
    conferenceDateFrom: Date;
    conferenceDateTo: Date;
    conferenceLocation: SpeakerInvitationCreateLocation;
    speakers: Speaker[];
    conferenceDates: SpeakerInvitationDay[]
    banquet: SpeakerInvitationCreateBanquet;
    parking: boolean;
    hotel: boolean;
}

export interface AdditionalSupport {
    showParking: boolean;
    showHotel: boolean;
    showBanquet: boolean;
    banquetLocation: string;
    parkingCount: number;
    hotelCount: number;
    banquetCount: number;
}

export enum AllowedParticipationType {
    OnSite = 1,
    Remote = 2,
    Hybrid = 3
}

